import { SEARCH_SUGGESTION_FALLBACK_ID } from 'constants/index';
import { SearchSuggestionType } from 'constants/search';
export const buildFallbackSuggestion = (title, query) => ({
  id: SEARCH_SUGGESTION_FALLBACK_ID,
  title,
  query,
  type: SearchSuggestionType.Fallback
});